export default __webpack_public_path__ + "static/media/gl-3.272af7af.png";